// extracted by mini-css-extract-plugin
export var lg = "_f9-7";
export var md = "_f9-6";
export var placeholderContainer = "_f9-1";
export var placeholderIcon = "_f9-2";
export var productImage = "_f9-0";
export var sm = "_f9-5";
export var xl = "_f9-8";
export var xs = "_f9-4";
export var xxs = "_f9-3";